<template>
    <div>
        <div class="form-group">
            <div class="row">
                <div class="col-3">
                    <label>{{resource('JourneyBuilder_TouchpointInfo_BrickName_Label')}}</label>
                </div>
                <div class="col-9">
                    {{name}}
                </div>
                
                <div class="col-3">
                    <label>{{resource('JourneyBuilder_TouchpointInfo_BrickType_Label')}}</label>
                </div>
                <div class="col-9">
                    {{typeName}}
                </div>
            </div>
        </div>

        <touchpoint-info-connection-list
                class="form-group"
                
                :direction="resource('JourneyBuilder_TouchpointInfo_Direction_Out')"
                :connections-info="outgoingConnectionsInfo"
        >
        </touchpoint-info-connection-list>
        
        <touchpoint-info-connection-list
            class="form-group"

            :direction="resource('JourneyBuilder_TouchpointInfo_Direction_In')"
            :connections-info="incomingConnectionsInfo"
        >
        </touchpoint-info-connection-list>
    </div>
</template>

<script>
    import {brickDefinitions} from "@modules/JourneyBuilder/Bricks/brick-definitions";

    import resourceMixin from "@core/Util/Mixins/resources";
    
    import TouchpointInfoConnectionList from "./TouchpointInfoConnectionList.vue";
    
    export default {
        name: 'touchpoint-info',
        components: {
            TouchpointInfoConnectionList
        },
        mixins: [resourceMixin],
        computed: {
            typeName(){
                return brickDefinitions[this.type].displayName;
            }
        },
        props: {
            name: {
                type: String,
                required: true
            },
            type: {
                type: Number,
                required: true
            },
            config: {
                type: Object,
                required: true
            },
            incomingConnectionsInfo: {
                type: Array,
                required: true
            },
            outgoingConnectionsInfo: {
                type: Array,
                required: true
            }
        }
    }
</script>